var map = {
	"./bigquery.png": "27aa",
	"./ftp.png": "c50d",
	"./gmail.png": "f50c",
	"./google_drive.png": "5f47",
	"./s3.png": "fc11",
	"./spreadsheet.png": "9b05"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1eb7";